import { useState } from "react";
import { PROJECTS } from "../data/divisions";
import { Reveal } from "../components/Reveal";

const FILTERS = [
  { value: "all", label: "All" },
  { value: "construction", label: "Construction" },
  { value: "import-export", label: "Import-Export" },
  { value: "it-services", label: "IT Services" },
];

const LABELS = { "construction":"Construction","import-export":"Import-Export","it-services":"IT Services" };

export default function Portfolio() {
  const [filter, setFilter] = useState("all");
  const filtered = filter === "all" ? PROJECTS : PROJECTS.filter(p => p.division === filter);
  return (
    <div className="pt-16 md:pt-20" data-testid="page-portfolio">
      <section className="max-w-[1400px] mx-auto px-6 md:px-12 py-20 md:py-28">
        <div className="text-xs uppercase tracking-[0.3em] text-forest font-semibold mb-6">Projects & Portfolio</div>
        <h1 className="text-5xl sm:text-6xl lg:text-8xl font-extrabold text-navy tracking-tighter leading-[0.95] max-w-5xl">
          Selected work across the group.
        </h1>
        <div className="mt-8 inline-flex items-center gap-2 rounded-full border border-stone bg-stone/60 px-4 py-2 text-xs text-slate" data-testid="portfolio-placeholder-notice">
          <span className="w-1.5 h-1.5 rounded-full bg-forest" />
          Placeholder imagery — real project photos coming soon.
        </div>
      </section>
      <section className="max-w-[1400px] mx-auto px-6 md:px-12 pb-24">
        <div className="flex flex-wrap gap-2 mb-10">
          {FILTERS.map(f => (
            <button
              key={f.value}
              data-testid={`portfolio-filter-${f.value}`}
              onClick={() => setFilter(f.value)}
              className={`rounded-full px-5 py-2 text-sm font-medium transition-colors border ${
                filter === f.value ? "bg-navy text-white border-navy" : "bg-white text-navy border-stone hover:border-navy/40"
              }`}
            >
              {f.label}
            </button>
          ))}
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {filtered.map((p, i) => (
            <Reveal key={p.id} delay={i}>
              <div className="rounded-2xl overflow-hidden border border-stone bg-white card-lift" data-testid={`portfolio-item-${p.id}`}>
                <div className="relative aspect-[4/3] overflow-hidden">
                  <img src={p.image} alt={p.title} loading="lazy" className="w-full h-full object-cover"/>
                  <span className="absolute top-3 left-3 rounded-full bg-white/90 backdrop-blur px-2.5 py-1 text-[10px] font-semibold uppercase tracking-widest text-navy">Sample</span>
                </div>
                <div className="p-6">
                  <div className="text-xs uppercase tracking-widest font-semibold text-forest mb-2">{LABELS[p.division]}</div>
                  <div className="text-xl font-bold text-navy tracking-tight">{p.title}</div>
                  <p className="mt-2 text-slate text-sm">{p.description}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
        {filtered.length === 0 && <div className="text-slate">No projects yet in this category.</div>}
      </section>
    </div>
  );
}
